import React, { Component } from 'react'
import styled from 'styled-components'
import classNames from 'classnames';
import ReactDOM from 'react-dom';

const Wrapper = styled.div`

    &.tile {
        position: relative;
        background: white;
        box-shadow: 0 1px 4px 0 rgba(0,0,0,0.30);
        border-radius: 2px;
        width: 290px;
        height: 157px;

        // Mobile version.
        @media (max-width: 768px) {
            width: 100%;
        }

        > div.tileHeader {
            background: #BABABA;
            text-transform: uppercase;
            font-family: Lato-Regular;
            font-size: 12px;
            color: #666666;
            line-height: 16px;
            margin: 0;
            padding: 6px 15px 7px 15px;
        }

        > div.button {
            position: absolute;
            z-index: 2;
            right: 0;
            width: 69px;
            height: 24px;
    
            background: #181821;
            border-style: none;
    
            font-family: Lato-Regular;
            font-size: 12px;
            color: #FFFFFF;
            line-height: 16px;
            text-align: center;
            padding-top: 5px;
            padding-left: 15px;

            :before {
                content: " ";
                background-color: #BABABA;
                width: 29px;
                height: 29px;
                position: absolute;
                left: -15px;
                top: 0px;
                border-radius: 15px;
            }
        }

        > p {
            font-family: Lato-Light;
            font-size: 24px;
            color: #1D71BB;
            line-height: 28px;
            margin: 0;
            padding: 9px 15px 10px 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        > div.tileFooter {
            margin: 0 10px 0 10px;
            width: 270px;
            height: 80px;
            border-top: 1px solid #CCCCCC;

            > p {
                font-family: Lato-Regular;
                font-size: 14px;
                color: #666666;
                line-height: 22px;
                padding: 6px 5px 0 5px;
                margin: 0;

                a {
                    cursor: pointer;
                }
            }

            > div {
                font-family: Lato-Regular;
                font-size: 14px;
                color: #666666;
                line-height: 22px;
                padding: 6px 5px 0 5px;
                margin: 0;
                height: calc(100% - 6px);

                > div.tileFooterTop {
                    border-bottom: 1px solid #CCCCCC;
                }
            }
        }
    }

    &.green {
        background: #129FA9;
        border-color: #09747C;

        > footer {
            border-top-color: #09747C;
        }
    }

    &.dark {
        background: #303042;
        border-color: #181821;

        > footer {
            border-top-color: #181821;
        }
    }

    &.green, > &.dark {
        > h3 {
            color: #FFFFFF;
            text-shadow: 1px 1px 0 #09747C;
        }

        > h1 {
            color: #FFFFFF;
            text-shadow: 1px 1px 0 #09747C;
        }

        > footer > p {
            color: #FFFFFF;
        }
    }

    &.is-clickable {
        cursor: pointer;
    }
`

export class Tile extends Component {

    constructor(props) {
        super(props);
        this.state = {visited: false};
    }

    getDOMNode = () => {
        return ReactDOM.findDOMNode(this);
    }

    onTileClicked = () => {
        if(this.props.onTileClicked != null) {
            this.props.onTileClicked(this.props.obj)
            this.setState({visited: true});
        }
    }

    onFooterClicked = () => {
        if(this.props.onFooterClicked != null) {
            this.props.onFooterClicked(this.props.obj)
        }
    }

    render() {
        const { theme, isClickable } = this.props;

        var tileClasses = classNames({
            'tile': true,
            'green': theme === 'green',
            'dark': theme === 'dark',
            "is-clickable": isClickable,
            "visited": this.state.visited
        });

        //var eventsOptions = getEventsMenuOptions(t, events);

        return (
            <Wrapper className={tileClasses}>
                {this.props.headerButtonLabel &&
                        <div className="button show-next-vest-events">{this.props.headerButtonLabel}</div>
                }
                <div className="tileHeader">
                    {this.props.date && this.props.date}&nbsp;

                </div>
                {!this.props.onTileClicked &&
                    <p title={this.props.info}>{this.props.info}</p>
                }
                {this.props.onTileClicked &&
                    <div><button className="tileButton" tabIndex="0" aria-haspopup="true" onClick={this.onTileClicked} title={this.props.info}>{this.props.info}</button></div>
                }
                <div className="tileFooter">
                    {!this.props.onFooterClicked &&
                        <div style={{positiion: 'absolute'}}>
                            <div className={this.props.footerTop && this.props.footerMid && "tileFooterTop"}>{this.props.footerTop}</div>
                            <div>{this.props.footerMid}&nbsp;{this.props.footerBottom && this.props.footerMidLabel}</div>
                            <div>{this.props.footerBottom}&nbsp;{this.props.footerBottom && this.props.footerBottomLabel}</div>
                        </div>
                    }
                    {this.props.onFooterClicked &&
                        <p><a tabIndex="0" role="button" aria-haspopup="true" onClick={this.onFooterClicked}>{this.props.footer}</a></p>
                    }
                </div>
            </Wrapper>
        )
    }
}

export default Tile;
